const config = {
  /**
   * staging
   * @returns object
   */
  get staging() {
    return {
      baseURL: import.meta.env.VITE_APP_API_DOMAIN,
      ticketURL: import.meta.env.VITE_APP_TICKET_URL,
      helpCenterURL: import.meta.env.VITE_APP_HELP_CENTER_URL,
      maintenanceAPI: import.meta.env.VITE_MAINTENANCE_API,
    };
  },
  /**
   * production
   * @returns object
   */
  get production() {
    return {
      baseURL: import.meta.env.VITE_APP_API_DOMAIN,
      ticketURL: import.meta.env.VITE_APP_TICKET_URL,
      helpCenterURL: import.meta.env.VITE_APP_HELP_CENTER_URL,
      maintenanceAPI: import.meta.env.VITE_MAINTENANCE_API,
    };
  },
  /**
   * isStaging
   * @returns object
   */
  isStaging: () => {
    if (import.meta.env.VITE_APP_MODE !== 'production') {
      return true;
    }
    return false;
  },
};

/**
 * getSetting
 * @param key ..
 * @returns object
 */
const getSetting = (key: string) => {
  if (config.isStaging()) {
    return (config.staging as any)[key];
  }
  return (config.production as any)[key];
};

export default {
  ...config,
  getSetting,
};
